import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var ValidationGift = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.452.921a1.172 1.172 0 00-1.626.316c-.475.705-.535 1.633-.57 2.607 1.087-.372 2.95-.837 2.69-2.174l-.49-.75-.004.001zM5.298 2.311l-.004.001c-.339.44-.25 1.24.32 1.625.682.46 1.848.31 2.815.262-.397-.89-.8-1.728-1.505-2.203a1.172 1.172 0 00-1.626.315zM10.699 7.588l-.306-1.573-1.278.248 3.053 15.706 1.278-.248zM19.356 4.175l-7.607 1.479.248 1.278 7.607-1.48zM1.003 9.068l6.968-1.354-.248-1.278L.116 7.915l.248 1.278zM4.513 23.457l6.28-1.22-2.67-13.743-6.281 1.22zM21.101 20.233L18.43 6.49l-6.28 1.221 2.67 13.743z"
  })));
});
ValidationGift.displayName = 'ValidationGift';

export { ValidationGift, ValidationGift as default };
